import axios from "axios";
import services from "@/config/services";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

export default class FatturePraticheCeiService {
  static interceptorSet = false;

  constructor() {
    this.praticheUrl = `${services.ask_pratiche_base.url}`;
    this.basePath = `${this.praticheUrl}/api/fatture-pratiche/cei`;

    this.paths = {
      rows: `${this.basePath}/rows`,
    };

    this.filemanager = new FileManager();

    if (!FatturePraticheCeiService.interceptorSet) {
      axios.interceptors.request.use((req) => {
        req.headers["Authorization"] = authHeader();
        req.headers["Params"] = Cookies.get("google_access_token") || Cookies.get("ask_access_token");
        return req;
      });

      FatturePraticheCeiService.interceptorSet = true;
    }
  }

  async getRows(params = {}) {
    const safeParams = {
      page: params.page ?? 1,
      per_page: params.per_page ?? 25,
    };

    const res = await axios.get(this.paths.rows, { params: safeParams });
    return res.data;
  }
}